/**
 * Clipflow 브랜드 로고 컴포넌트
 * - 가로형 풀로고 (symbol + wordmark)
 * - PNG 자산 비율: 381 x 92 (~4.14:1)
 * - light 자산 = 워드마크 화이트 (다크 표면용)
 * - dark 자산  = 워드마크 네이비 (라이트 표면용 — 현 프로젝트 다크 단일이라 거의 미사용)
 */
import Image from 'next/image'
import type { CSSProperties } from 'react'

const CLIPFLOW_LOGO_AR = 381 / 92

interface ClipflowLogoProps {
  /** 높이(px). 가로폭은 비율로 자동 계산 */
  height?: number
  /** 다크 표면용 화이트 워드마크 (기본 true) */
  onDark?: boolean
  className?: string
  style?: CSSProperties
  priority?: boolean
}

export function ClipflowLogo({
  height = 28,
  onDark = true,
  className,
  style,
  priority,
}: ClipflowLogoProps) {
  const src = onDark ? '/brand/clipflow-logo-light.png' : '/brand/clipflow-logo-dark.png'
  const width = Math.round(height * CLIPFLOW_LOGO_AR)
  return (
    <Image
      src={src}
      alt="Clipflow"
      width={width}
      height={height}
      priority={priority}
      className={className}
      style={{
        height,
        width,
        display: 'block',
        objectFit: 'contain',
        ...style,
      }}
    />
  )
}

/**
 * Clipflow 심볼만 (워드마크 제외)
 * 1:1 비율의 마크 PNG 사용
 */
interface ClipflowMarkProps {
  size?: number
  onDark?: boolean
  className?: string
  style?: CSSProperties
  priority?: boolean
}

export function ClipflowMark({
  size = 28,
  onDark = true,
  className,
  style,
  priority,
}: ClipflowMarkProps) {
  // mark.png 자체가 1:1 — 단순히 정사각 이미지로 렌더
  // 다크/라이트 표면 모두 같은 컬러풀 마크 사용 (워드마크와 달리 마크는 색상 변경 불필요)
  const src = '/brand/clipflow-mark.png'
  return (
    <Image
      src={src}
      alt="Clipflow"
      width={size}
      height={size}
      priority={priority}
      className={className}
      style={{
        width: size,
        height: size,
        display: 'block',
        objectFit: 'contain',
        flexShrink: 0,
        ...style,
      }}
    />
  )
}
